module.exports = __webpack_public_path__ + "img/jackpot_2-01.b43cdb28.png";